import { render, staticRenderFns } from "./order_history.vue?vue&type=template&id=2390956a&scoped=true&"
import script from "./order_history.vue?vue&type=script&lang=js&"
export * from "./order_history.vue?vue&type=script&lang=js&"
import style0 from "./order_history.vue?vue&type=style&index=0&id=2390956a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2390956a",
  null
  
)

export default component.exports